<template>
    <div class="history-page">
        <el-form ref="form" :model="form" label-width="80px" inline>
            <el-form-item label="事件类型">
                <el-select 
                v-model="form.test_type" 
                placeholder="请选择事件类型"
                size="small"
                class="el-green"
                @change="testTypeChange">
                    <el-option 
                    v-for="test_type in list.test_type" 
                    :key="test_type.value"
                    :label="test_type.label" 
                    :value="test_type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
                <el-select 
                v-model="form.test_starttime" 
                placeholder="请选择开始时间"
                class="el-green"
                size="small">
                    <el-option 
                    v-for="test_starttime in list.test_starttime" 
                    :key="test_starttime.value"
                    :label="test_starttime.label" 
                    :value="test_starttime.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" 
                icon="el-icon-search"
                @click="searchHistoryData">查询</el-button>
            </el-form-item>
        </el-form>
        <line-chart id="analogValue" ref="analogValue" title="模拟量曲线图显示" :height=400></line-chart>
        <line-chart id="switchValue" ref="switchValue" title="开关量显示" :height=300></line-chart>
        <line-chart id="stateValue" ref="stateValue" title="状态量显示" :height=300></line-chart>
    </div>
</template>

<script>
// 引入 ECharts 主模块
import ECharts from "echarts/lib/echarts";
import LineChart from '@/components/chart/LineChart'

export default {
    name: 'PagesHistory',
    components: {
        LineChart
    },
    data() {
        return {
            form: {
                test_type: '',
                test_starttime: ''
            },
            list: {
                test_type: [],
                test_starttime: [],
                test_data: []
            },
            options: {
                analog: {
                    xAxis: {
                        data: []
                    },
                    series: []
                },
                switch: {
                    xAxis: {
                        data: []
                    },
                    series: []
                },
                state: {
                    xAxis: {
                        data: []
                    },
                    series: []
                }
            }
        }
    },
    watch: {
        '$store.state.batt': function() {
            this.searchTestTypeList();
        },
    },
    methods: {
        searchTestTypeList() {
            // 初始化数据
            this.form.test_type = "";
            this.form.test_starttime = "";
            this.list.test_type = [];
            this.list.test_starttime = [];
            this.list.test_data = [];

            var batt  = this.$store.state.batt;
            // 没有dev_id不进行查询
            if(batt.dev_id == '') {
                return;
            }
            var self = this;
			// 查询后台
			this.$axios({
				method: 'post',
				url: 'Eventdata_infAction!serchByCondition',
				data: 'json='+JSON.stringify({
                    dev_id: batt.dev_id,
                }),
			}).then((res)=>{
				var data = [];
				if(res.code == 1) {
					data = res.data;
                }
                // 遍历data的值
                for(var i=0; i<data.length; i++) {
                    var _data = data[i];
                    var tmp = {
                        label: '事件类型'+_data,
                        value: _data,
                    };
                    self.list.test_type.push(tmp);
                }
			}).catch((error)=>{
				console.log(error);
			});
        },
        testTypeChange() {
            // 初始化数据
            this.form.test_starttime = "";
            this.list.test_starttime = [];
            this.list.test_data = [];

            var batt  = this.$store.state.batt;
            var form = this.form;
            // 没有dev_id不进行查询
            if(batt.dev_id == '') {
                return;
            }
            var self = this;
			// 查询后台
			this.$axios({
				method: 'post',
				url: 'Eventdata_infAction!serchByInfo',
				data: 'json='+JSON.stringify({
                    dev_id: batt.dev_id,
                    test_type: form.test_type,
                }),
			}).then((res)=>{
				var data = [];
				if(res.code == 1) {
					data = res.data;
                }
                // 测试数据信息
                self.list.test_data = data;
                // 遍历data的值
                for(var i=0; i<data.length; i++) {
                    var _data = data[i];
                    var tmp = {
                        label: _data.test_starttime,
                        value: i,
                    };
                    self.list.test_starttime.push(tmp);
                }
			}).catch((error)=>{
				console.log(error);
			});
        },
        searchHistoryData() {
            var checkFromData = this.checkFromData();
            if(checkFromData.code == 0) {
                // 提示信息
                this.$message({
                    message: checkFromData.msg,
                    type: 'warning',
                });
                return;
            }
            
            // 查询后台
			this.$axios({
				method: 'post',
				url: 'EventdataAction!serchByCondition',
				data: 'json='+JSON.stringify(checkFromData.data),
			}).then((res)=>{
				var data = [];
				if(res.code == 1) {
					data = res.data;
                }
                this.formatHistoryData(data);
			}).catch((error)=>{
				console.log(error);
			});
        },
        checkFromData() {
            var result = {
                code: 1,
                msg: '条件符合',
                data: []
            };
            var batt  = this.$store.state.batt;
            var form = this.form;
            // 没有dev_id不进行提示
            if(batt.dev_id == '') {
                result.code = 0;
                result.msg =  '请选择站点';
                return result;
            }

            // 测试类型
            if(form.test_type+'' == '') {
                result.code = 0;
                result.msg =  '请选择测试类型';
                return result;
            }
            // 测试类型
            if(form.test_starttime+'' == '') {
                result.code = 0;
                result.msg =  '请选择测试开始时间';
                return result;
            }

            result.data = this.list.test_data[form.test_starttime];
            return result;
        },
        initOptions() {
            // 模拟量配置项初始化
            this.options.analog.xAxis.data = [];
            this.options.analog.series = [];

            // 开关量配置项初始化
            this.options.switch.xAxis.data = [];
            this.options.switch.series = [];

            // 状态量配置项初始化
            this.options.state.xAxis.data = [];
            this.options.state.series = [];
        },
        formatHistoryData(data) {
            var batt = this.$store.state.batt;
            this.initOptions();
            // 遍历data的值
            for(var i=0; i<data.length; i++) {
                var _data = data[i];
                // 记录时间
                if(_data.am_num == 1) {
                    // 模拟量配置项
                    this.options.analog.xAxis.data.push(_data.record_time);
                    // 开关量
                    this.options.switch.xAxis.data.push(_data.record_time);
                    // 状态量
                    this.options.state.xAxis.data.push(_data.record_time);
                }
                var index = _data.am_num - 1;
                // 模拟量配置项
                if(_data.am_num <= batt.analog_count) {
                    if(this.options.analog.series[index] == undefined) {
                        this.options.analog.series[index] = {
                            name: '模拟量'+_data.am_num,
                            type: 'line',
                            smooth: true,
                            symbolSize: 6,
                            data: [_data.analog_value]
                        };
                    }else {
                        this.options.analog.series[index].data.push(_data.analog_value)
                    }
                }

                // 开关量switch_value
                if(_data.am_num <= batt.switch_count) {
                    if(this.options.switch.series[index] == undefined) {
                        this.options.switch.series[index] = {
                            name: '开关量'+_data.am_num,
                            type: 'line',
                            smooth: true,
                            symbolSize: 6,
                            data: [_data.switch_value]
                        };
                    }else {
                        this.options.switch.series[index].data.push(_data.switch_value)
                    }
                }

                // 开关量state_value
                if(_data.am_num <= batt.state_count) {
                    if(this.options.state.series[index] == undefined) {
                        this.options.state.series[index] = {
                            name: '状态量'+_data.am_num,
                            type: 'line',
                            smooth: true,
                            symbolSize: 6,
                            data: [_data.state_value]
                        };
                    }else {
                        this.options.state.series[index].data.push(_data.state_value)
                    }
                }
            }
            // 设置图表
            this.setOptions();
        },
        setOptions() {
            // 模拟量
            this.$refs.analogValue.setOption(this.options.analog);

            // 开关量
            this.$refs.switchValue.setOption(this.options.switch);

            // 状态量
            this.$refs.stateValue.setOption(this.options.state);

            // 或者可以直接传入需要联动的实例数组
            ECharts.connect([this.$refs.analogValue.chart
            , this.$refs.switchValue.chart, this.$refs.stateValue.chart]);
        },
    },
    mounted() {
        // 查询事件类型
        this.searchTestTypeList();
    }
}
</script>

<style scoped>

</style>


